import { message } from 'antd';

// Normalize base URL and ensure it targets v1 API
const RAW_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/';
const NORMALIZED_BASE = RAW_BASE_URL.endsWith('/') ? RAW_BASE_URL : `${RAW_BASE_URL}/`;
const API_BASE_V1 = NORMALIZED_BASE.includes('/v1/') ? NORMALIZED_BASE : `${NORMALIZED_BASE}v1/`;

class EhrmConfigApi {
  // Get auth token from localStorage
  getAuthToken() {
    return localStorage.getItem('authToken');
  }

  // Get EHRM configuration
  async getConfig() {
    try {
      const response = await fetch(`${API_BASE_V1}settings/ehrm`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${this.getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          // No config exists yet
          return null;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching EHRM config:', error);
      message.error('Failed to fetch EHRM configuration');
      throw error;
    }
  }

  // Create EHRM configuration
  async createConfig(configData) {
    try {
      const response = await fetch(`${API_BASE_V1}settings/ehrm`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(configData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      message.success('EHRM configuration created successfully');
      return result;
    } catch (error) {
      console.error('Error creating EHRM config:', error);
      message.error(`Failed to create EHRM configuration: ${error.message}`);
      throw error;
    }
  }

  // Update EHRM configuration
  async updateConfig(configData) {
    try {
      const response = await fetch(`${API_BASE_V1}settings/ehrm`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${this.getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(configData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      message.success('EHRM configuration updated successfully');
      return result;
    } catch (error) {
      console.error('Error updating EHRM config:', error);
      message.error(`Failed to update EHRM configuration: ${error.message}`);
      throw error;
    }
  }

  // Test EHRM connection
  async testConnection(configData) {
    try {
      const response = await fetch(`${API_BASE_V1}settings/ehrm/test`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(configData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.success) {
        message.success('Connection test successful!');
      } else {
        message.error(`Connection test failed: ${result.message}`);
      }
      
      return result;
    } catch (error) {
      console.error('Error testing EHRM connection:', error);
      message.error(`Connection test failed: ${error.message}`);
      throw error;
    }
  }
}

export default new EhrmConfigApi();
